/*eslint-disable*/
import parse from "html-react-parser";

const SubHeader = ({ title, className }) => {
	return (
		<div className={`banner-section ${className}`}>
			<div className='page-title'>
				<h1 className='title tagh1'>{parse(`${title}`)}</h1>
			</div>
		</div>
	);
};

export default SubHeader;
